export const INSERT_ER_NEW = "INSERT_ER_NEW";
export const INSERT_ER_MEDICATION_HISTORY = "INSERT_ER_MEDICATION_HISTORY";
